import * as React from 'react';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material';
import css from './ThemeProvider.module.scss';
const theme = createTheme({
  palette: {
    primary: { main: '#4A58EC' },
  },
  typography: {
    fontFamily: 'Open Sans, sans-serif',
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiTable: {
      defaultProps: { sx: { borderColor: '#F9F9F9' } },
    },
    MuiTableContainer: {
      defaultProps: {
        classes: { root: css.paperRoot },
      },
    },
    MuiTableCell: {
      defaultProps: {
        classes: {
          root: css.tableRoot,
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        classes: css.paperRoot,
      },
    },
    MuiSelect: {
      defaultProps: {
        classes: {
          root: css.selectRoot,
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        classes: {
          root: css.controlRoot,
        },
      },
    },
    MuiAutocomplete: { defaultProps: { classes: { root: css.selectRoot } } },
    MuiOutlinedInput: {
      defaultProps: {
        classes: {
          root: css.inputRoot,
          notchedOutline: css.inputRoot,
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        classes: {
          tooltip: css.tooltipRoot,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        classes: {
          root: css.buttonRoot,
          text: css.buttonText,
          outlined: css.buttonOutline,
          sizeMedium: css.sizeMedium,
        },
      },
    },
    MuiMenuItem: {
      defaultProps: {
        classes: {
          root: css.menuItemRoot,
          selected: css.menuItemSelected,
        }
      }
    }
  },
});

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => (
  <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>
);